module.exports = __webpack_public_path__ + "img/2025-03-18-01-02.45f20cc0.png";